import { Link } from "react-router-dom";

export const JourneyShell = ({ children }) => (
  <main className="journey-page" data-testid="journey-page">
    <header className="journey-header" data-testid="journey-header">
      <Link to="/" data-testid="journey-home-link" aria-label="Supple home">
        <img src="/brand/supple-logo-transparent.png" alt="Supple" />
      </Link>
    </header>
    <div className="journey-content">{children}</div>
  </main>
);